// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  padding: '0 10px 10px 10px',
})
